import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

import { RoutalPlaceIcon } from '../../../../assets/svg/RoutalPlaceIcon';
import { Text } from '../../../../react-components/Text';

interface StopsProgressProps {
  completedStops?: number;
  canceledStops?: number;
  incompleteStops?: number;
  tasksEnabled?: boolean;
}

export const StopsProgress = ({
  completedStops = 0,
  canceledStops = 0,
  incompleteStops = 0,
  tasksEnabled = false,
}: StopsProgressProps) => {
  const data =
    incompleteStops === 0 && completedStops === 0 && canceledStops === 0
      ? [{ value: 100, color: RoutalPalette.neutral10 }]
      : [
          ...(completedStops > 0 ? [{ value: completedStops, color: RoutalPalette.success.medium }] : []),
          ...(canceledStops > 0 ? [{ value: canceledStops, color: RoutalPalette.error.medium }] : []),
          ...(incompleteStops > 0 ? [{ value: incompleteStops, color: RoutalPalette.warning.medium }] : []),
        ];

  return (
    <div
      style={{
        position: `relative`,
        width: `100%`,
        display: `flex`,
        flexDirection: `column`,
        justifyContent: `center`,
        alignItems: `center`,
      }}
    >
      <ResponsiveContainer width="100%" height={150}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            startAngle={210}
            endAngle={-30}
            cx="50%"
            cy="65%"
            innerRadius={74}
            outerRadius={80}
            cornerRadius={10}
            paddingAngle={5}
            isAnimationActive={true}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} stroke="none" strokeWidth={2} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <Grid
        container
        direction="column"
        wrap="nowrap"
        justifyContent="center"
        alignItems="center"
        style={{
          position: `absolute`,
          top: `50%`,
          left: `50%`,
          transform: `translate(-51%, -20%)`,
        }}
      >
        <Grid container direction="row" wrap="nowrap" justifyContent="center" alignItems="center" gap="4px">
          <div
            style={{
              width: `6px`,
              height: `6px`,
              borderRadius: `50%`,
              backgroundColor: RoutalPalette.success.medium,
            }}
          />
          <Text variant="h6" style={{ color: RoutalPalette.white }}>
            {completedStops}
          </Text>
        </Grid>
        <Grid container direction="row" wrap="nowrap" justifyContent="center" alignItems="center" gap="4px">
          <div
            style={{
              width: `6px`,
              height: `6px`,
              borderRadius: `50%`,
              backgroundColor: RoutalPalette.error.medium,
            }}
          />
          <Text variant="body-medium" style={{ color: RoutalPalette.white }}>
            {canceledStops}
          </Text>
        </Grid>

        {tasksEnabled && (
          <Grid container direction="row" wrap="nowrap" justifyContent="center" alignItems="center" gap="4px">
            <div
              style={{
                width: `6px`,
                height: `6px`,
                borderRadius: `50%`,
                backgroundColor: RoutalPalette.warning.medium,
              }}
            />
            <Text variant="body-medium" style={{ color: RoutalPalette.white }}>
              {incompleteStops}
            </Text>
          </Grid>
        )}

        <Grid
          container
          direction="row"
          wrap="nowrap"
          justifyContent="center"
          alignItems="center"
          gap="4px"
          style={{ marginTop: `6px` }}
        >
          <RoutalPlaceIcon color={RoutalPalette.white} />
          <Text variant="small" style={{ color: RoutalPalette.white }} intlId="drivers.home_analytics_summary.stops" />
        </Grid>
      </Grid>
    </div>
  );
};
